import type { NavItem } from '@/components/UiNavigation/UiNavigation.types'

export const PARTNERS_SUB_MENU_ITEMS: NavItem[] = [
  {
    label: 'partners.submenu.zone.label',
    link: 'partners.submenu.zone.link',
    external: true,
  },
  {
    label: 'partners.submenu.fairPlay.label',
    link: 'partners.submenu.fairPlay.link',
    external: false,
  },
  {
    label: 'partners.submenu.conditions.label',
    link: 'partners.submenu.conditions.link',
    external: true,
  },
]
